// to track google analytics 4
window.dataLayer = window.dataLayer || [];
function gtag() {
    dataLayer.push(arguments);
}

window.scrollTo({  
    top: 0,  
    behavior: 'smooth' // Smooth scrolling  
}); 

gtag('js', new Date());
gtag('config', 'YOUR_MEASURMENT_ID');

$(".q_button").on("click", function () {
    var answer = $(this).data("answer");

    // send event to google analytics
    gtag("event", "select_answer", {
        event_category: "Answers",
        event_label: answer,
        value: 1
    });
});

// to active elem css
let index = 0;
let q_index = 0;

$(".animation_btn").on("click", function () {
    next();
});

$("#qb_1").on("click", function () {
    q_index = 0;
    qShowSlide(0);
    $("#qb_1").addClass("active");
    $("#qb_2").removeClass("active");
    $("#qb_3").removeClass("active");
    $("#qb_4").removeClass("active");
    $("#qb_5").removeClass("active");
    $("#qb_buy").removeClass("active");
});

$("#qb_2").on("click", function () {
    q_index = 1;
    qShowSlide(1);
    $("#qb_2").addClass("active");
    $("#qb_1").removeClass("active");
    $("#qb_3").removeClass("active");
    $("#qb_4").removeClass("active");
    $("#qb_5").removeClass("active");
    $("#qb_buy").removeClass("active");
});

$("#qb_3").on("click", function () {
    q_index = 2;
    qShowSlide(2);
    $("#qb_3").addClass("active");
    $("#qb_1").removeClass("active");
    $("#qb_2").removeClass("active");
    $("#qb_4").removeClass("active");
    $("#qb_5").removeClass("active");
    $("#qb_buy").removeClass("active");
});

$("#qb_4").on("click", function () {
    q_index = 3;
    qShowSlide(3);
    $("#qb_4").addClass("active");
    $("#qb_1").removeClass("active");
    $("#qb_2").removeClass("active");
    $("#qb_3").removeClass("active");
    $("#qb_5").removeClass("active");
    $("#qb_buy").removeClass("active");
});

$("#qb_5").on("click", function () {
    q_index = 4;
    qShowSlide(4);
    $("#qb_5").addClass("active");
    $("#qb_1").removeClass("active");
    $("#qb_2").removeClass("active");
    $("#qb_3").removeClass("active");
    $("#qb_4").removeClass("active");
    $("#qb_buy").removeClass("active");
});

$("#qb_buy").on("click", function () {
    q_index = 5;
    qShowSlide(5);
    $("#qb_buy").addClass("active");
    $("#qb_1").removeClass("active");
    $("#qb_2").removeClass("active");
    $("#qb_3").removeClass("active");
    $("#qb_4").removeClass("active");
    $("#qb_5").removeClass("active");
});

$(".q1").on("click", function () {
    qNext();
    $("#qb_1").removeClass("active");
    $("#qb_2").addClass("active");
});

$(".q2").on("click", function () {
    qNext();
    $("#qb_2").removeClass("active");
    $("#qb_3").addClass("active");
});

$(".q3").on("click", function () {
    qNext();
    $("#qb_3").removeClass("active");
    $("#qb_4").addClass("active");
});

$(".q4").on("click", function () {
    qNext();
    $("#qb_4").removeClass("active");
    $("#qb_5").addClass("active");
});

$(".buy").on("click", function () {
    qNext();
    $("#qb_5").removeClass("active");
    $("#buy").addClass("active");
});

// Set constants for heights  
const HEIGHT_LARGE = 2436; // Height for widths greater than 1125px  
const HEIGHT_SMALL = 216.53; // Height for widths less than or equal to 1125px  
const HEIGHT_LARGE_SP = 2256; // Height for widths greater than 1125px  
const HEIGHT_SMALL_SP = 200.53; // Height for widths less than or equal to 1125px  

function getWindowWidth() {  
    return window.innerWidth; // Get the current window width  
}  

function showSlide(n) {  
    const windowWidth = getWindowWidth(); // Get width dynamically  
    let offset; // Declare offset variable  
   
    if (windowWidth > 1125) {  
        offset = -n * HEIGHT_LARGE;  
        $(".slider_container").css({ "transform": `translateY(${offset}px)` });  
    } else {  
        offset = -n * HEIGHT_SMALL; // Use the same small height value  
        $(".slider_container").css({ "transform": `translateY(${offset}vw)` });  
    }  
}  

function qShowSlide(n) {  
    const windowWidth = getWindowWidth(); // Get width dynamically  
    let offset; // Declare offset variable  
   
    if (windowWidth > 1125) {  
        offset = -n * HEIGHT_LARGE_SP;  
        $(".q_slider_container").css({ "transform": `translateY(${offset}px)` });  
    } else {  
        offset = -n * HEIGHT_SMALL_SP; // Ensure using the correct height for consistency  
        $(".q_slider_container").css({ "transform": `translateY(${offset}vw)` });  
    }  
}  

function next() {
    showSlide(index += 1);

    window.scrollTo({  
        top: 0,  
        behavior: 'smooth' // Smooth scrolling  
    }); 
}

function qNext() {
    qShowSlide(q_index += 1);

    window.scrollTo({  
        top: 0,  
        behavior: 'smooth' // Smooth scrolling  
    }); 
}
